module.exports = __webpack_public_path__ + "fonts/VetoSansCond-LightItalic.cbd88af2.woff";